import ShareIcon from '@mui/icons-material/Share'
import VetSharesList from './VetSharesList'

export default {
  list: VetSharesList,
  icon: ShareIcon,
  recordRepresentation: (record: any) =>
    record.shareType === 'all_pets' ? 'All Pets' : `${record.sharedPets?.length || 0} Pets`,
}
